import { apiSpaceUrl } from "utils/urls";

import axios from "axios";

export const getSearchPapers = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("searchPapers", spaceUuid), { params: params });
    return data;
};

export const getConvertedSearchPapers = async (spaceUuid, body) => {
    const { data } = await axios.post(apiSpaceUrl("searchPapers", spaceUuid), body);
    return data;
};

export const getSearchHistory = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("searchHistory", spaceUuid), {
        params: params,
    });
    return data;
};

export const deleteSearchHistory = async (spaceUuid, body) => {
    const { data } = await axios.delete(apiSpaceUrl("searchHistory", spaceUuid), {
        data: body,
    });
    return data;
};

export const getSearchRecommendation = async (spaceUuid, params) => {
    const { data } = await axios.get(apiSpaceUrl("searchRecommendation", spaceUuid), {
        params: params,
    });
    return data;
};
